import * as React from 'react';
import { Select as AntSelect } from 'antd';

export type SelectOptionProps = {
  children: React.ReactNode;
};

const SelectOption = (props: SelectOptionProps & React.ComponentProps<typeof AntSelect.Option>) => {
  return <AntSelect.Option {...props} className="select-option" />;
};

SelectOption.defaultProps = {
  // TODO
};

export default SelectOption;
